// pages/Home.jsx
import React from 'react';
import CompetitionCard from '../components/CompetitionCard/CompetitionCard';

const Home = () => {
  const competitionData = {
    title: "Versenykiírás 2025",
    imageUrl: "/Assets/plakat.png",
    description: "Tekintse meg a legfrissebb versenykiírást és jelentkezzen!"
  };

  return (
    <div className="home-page full-height-container d-flex justify-content-center align-items-center p-3">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12 col-md-8 col-sm-10">
            <CompetitionCard 
              title={competitionData.title}
              imageUrl={competitionData.imageUrl}
              description={competitionData.description}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;